// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  bodyLgStyles,
  bodyStyles,
  FONT_SIZE_MEDIUM,
  FONT_WEIGHT_NORMAL_PP,
  HIGH_CONTRAST_TEXT_COLOR,
  PAYPAL_OPEN_FONT,
} from '@/styles';

export const valuePropHeaderStyles = css`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_MEDIUM};
  font-family: ${PAYPAL_OPEN_FONT};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  line-height: 1.2;
  margin: 15px 0 10px;

  .overrides-font-4-2 & {
    ${bodyLgStyles}
  }
`;

export const valuePropSubHeaderStyles = css`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: 14px;
  font-family: ${PAYPAL_OPEN_FONT};
  font-weight: 400;
  line-height: 20px;
  margin: 5px 0;

  .overrides-font-4-2 & {
    ${bodyStyles}
  }
`;
